<template>
  <view class="export_btn" :style="style">
    <view class="btn_container" @click="exportOptVisible = true">
      <img :src="ExportIcon" alt="导出" />
    </view>
    <view :class="{ 'export-container-masker': true, show: exportOptVisible }" flex="dir:left main:center cross:center" @click="hide">
      <view class="export-container" @click="prevent">
        <template v-if="exportStatus === 'choose'">
          <view class="export-header"> 导出{{ name }} </view>
          <view class="export-option">
            <radio-group v-model="exportType" :style="{ paddingLeft: '20px' }">
              <radio v-for="item of options" :key="item.value" :value="item.value">{{ item.label }}</radio>
            </radio-group>
          </view>
          <view class="export-footer">
            <view class="pft-btn default" @click="exportOptVisible = false">取消</view>
            <view class="pft-btn primary" @click="exportFn">确认</view>
          </view>
        </template>
        <template v-else-if="exportStatus === 'ing'">
          <view class="export-header"> 导出{{ name }} </view>
          <view class="export-option desc">{{ exportDesc }}</view>
        </template>
        <template v-else>
          <view class="export-header"> 导出{{ name }} </view>
          <view class="export-option desc">{{ exportDesc }}</view>
          <view class="export-footer center">
            <view class="pft-btn primary" @click="done">确定</view>
          </view>
        </template>
      </view>
    </view>
  </view>
</template>

<script setup lang="ts">
import { ref, watch } from "vue"
import Excel from "exceljs"
import ExportIcon from "@p-v/asset/image/icon_export.png"

import RadioGroup from "@p-v/component/radioGroup.vue"
import Radio from "@p-v/component/radio.vue"

const props = withDefaults(
  defineProps<{
    style: { [key: string]: string }
    options: { label: string; value: string; isTotal?: boolean }[]
    type?: string | number
    name: string
    listKey: string
    mapKey: { [key: string]: { width?: number; type?: string; colIndex?: number; value: (item: any, list: any[]) => number } }
    lastRow?: ((...arg: any[]) => string | number)[]
    api: any
    params?: (type: string | number) => {
      fileName?: string
      config: { [key: string]: { [key: string]: string | number } }
    }
  }>(),
  {
    style: () => ({}),
    options: () => [],
    type: undefined,
    name: () => "",
    listKey: () => "",
    mapKey: () => ({}),
    api: () => ({}),
    lastRow: () => [],
    params: (type: string | number) => ({
      fileName: "",
      config: {},
    }),
  },
)
const exportOptVisible = ref(false)
const exportType = ref(props.type || props.options[0].value)

const exportStatus = ref<"choose" | "ing" | "done">("choose")
const exportDesc = ref("")

const done = () => {
  exportOptVisible.value = false
  exportStatus.value = "choose"
  exportDesc.value = ""
}

const dealUnit = (sheet: Excel.Worksheet, list: any[], day: string) => {
  sheet.columns = Object.keys(props.mapKey).map(key => {
    return {
      header: key === "时间" ? day : key,
      key,
      width: props.mapKey[key].width || 20,
    }
  })
  const rows: any[][] = []
  if (Array.isArray(list)) {
    for (let item of list) {
      const li = rows.push(
        Object.keys(props.mapKey).map(key => {
          if (props.mapKey[key]) {
            return props.mapKey[key].value(item, list)
          }
          return item[key]
        }),
      )
      sheet.addRow(rows[li - 1])
    }
  }
  if (props.lastRow.length) {
    sheet.addRow(props.lastRow.map(fn => fn(list)))
  }
  return rows
}

const detailExport = async () => {
  exportStatus.value = "ing"
  exportDesc.value = "正在导出"
  const workbook = new Excel.Workbook()
  const types = Object.keys(props.mapKey).map(key => {
    return {
      type: props.mapKey[key].type,
      colIndex: props.mapKey[key].colIndex,
    }
  })
  // 汇总数据项
  const totalRows = Array.from({ length: types.length }, () => 0)
  const totalSheetRows: any[][] = []
  const params = props.params(exportType.value)
  const sheetNames = Object.keys(params.config)
  for (let sheetName of sheetNames) {
    exportDesc.value = `正在导出${sheetName}...`
    const sheet = workbook.addWorksheet(sheetName)
    console.log("query", params, params.config[sheetName])

    let tempList = await props.api(params.config[sheetName])
    props.listKey.split(".").forEach(key => {
      tempList = tempList[key]
    })
    const list = tempList as unknown as any[]
    const unitSheetRows = dealUnit(sheet, list, sheetName)

    // 计算汇总数据

    let keyIndex = types.findIndex(type => type.type === "key")
    if (keyIndex > -1) {
      for (let row of unitSheetRows) {
        // key 为唯一标识
        let curRow: any = null
        let isFirst = true
        const hasRow = totalSheetRows.find(r => r[keyIndex] === row[keyIndex])
        if (!hasRow) {
          const newI = totalSheetRows.push(row)
          curRow = totalSheetRows[newI - 1]
        } else {
          isFirst = false
          curRow = hasRow
        }
        if (curRow) {
          for (let i = 0; i < types.length; i++) {
            if (types[i].type === "number" && !isFirst) {
              curRow[i] += row[i]
            }
            if (types[i].type === "percent" && types[i].colIndex !== undefined) {
              totalRows[i] += row[types[i].colIndex!]
            }
          }
        }
      }
    }
  }

  const totalSheet = workbook.addWorksheet("汇总")
  totalSheet.columns = Object.keys(props.mapKey).map(key => {
    return {
      header: key,
      key,
      width: props.mapKey[key].width || 20,
    }
  })
  for (let item of totalSheetRows) {
    let row: any[] = []

    for (let i = 0; i < types.length; i++) {
      if (types[i].type === "percent") {
        row.push(parseFloat(((row[types[i].colIndex!] / totalRows[i]) * 100).toFixed(2)))
      } else {
        row.push(item[i])
      }
    }
    totalSheet.addRow(row)
  }

  exportStatus.value = "done"
  exportDesc.value = "导出完成"
  workbook.xlsx.writeBuffer().then(buffer => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `${params.fileName || props.name}.xlsx`
    a.click()
    URL.revokeObjectURL(url)
  })
}

const totalExport = async () => {
  exportStatus.value = "ing"
  exportDesc.value = "正在导出"
  const params = props.params(exportType.value)
  const workbook = new Excel.Workbook()

  const sheetNames = Object.keys(params.config)
  for (let sheetName of sheetNames) {
    const sheet = workbook.addWorksheet(sheetName)
    exportDesc.value = `正在导出${sheetName}...`
    console.log("query", params, params.config[sheetName])
    let tempList = await props.api(params.config[sheetName])
    props.listKey.split(".").forEach(key => {
      tempList = tempList[key]
    })
    const list = tempList as unknown as any[]
    dealUnit(sheet, list, sheetName)
  }
  exportStatus.value = "done"
  exportDesc.value = "导出完成"
  workbook.xlsx.writeBuffer().then(buffer => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `${params.fileNmae || props.name}.xlsx`
    a.click()
    URL.revokeObjectURL(url)
  })
}

const exportFn = async () => {
  const selected = props.options.find(item => item.value === exportType.value)
  if (selected?.isTotal) {
    totalExport().catch(error => {
      console.log("error", error)
    })
  } else {
    detailExport().catch(error => {
      console.log("error", error)
    })
  }
}

const hide = () => {
  exportOptVisible.value = false
}

const prevent = (e: Event) => {
  e.stopPropagation()
}
</script>

<style lang="scss">
.export-container-masker {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: none !important;
  &.show {
    display: flex !important;
    background: rgba(0, 0, 0, 0.5);
  }
}
.export_btn {
  z-index: 5;
  .btn_container {
    width: 24px;
    height: 24px;
    background: #ffffff17;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    img {
      width: 18px;
      height: 18px;
    }
  }
}
.export-container {
  padding: 15px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background: rgb(12 45 91);
  box-shadow: 0 0 5px 0 rgb(45 213 255);
  width: 650px;
  .export-header {
    padding: 5px;
    font-size: 16px;
    color: #fff;
    // border-bottom: 1px solid #fff;
  }
  .export-option {
    padding: 10px 0;
    font-size: 16px;
    &.desc {
      color: #fff;
      font-size: 14px;
      text-align: center;
    }
  }
  .export-footer {
    display: flex;
    justify-content: space-between;
    &.center {
      justify-content: center;
    }
    padding: 10px;
  }
}
.pft-btn {
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  &.default {
    background: #fff;
    color: #000;
  }
  &.primary {
    background: #1890ff;
    color: #fff;
  }
}
</style>
